<template>
    <el-popover trigger="click" placement="top" width="500">
        <div>
            <div class="flex_center" style="padding: 5px 0;">
                <div :class="current_plat_type != 2 ? 'm_checked_p0' : ''">
                    <el-button @click="current_plat_type = -1" link>通用表情</el-button>
                </div>
                <div :class="current_plat_type == 2 ? 'm_checked_p0' : ''">
                    <el-button @click="current_plat_type = 2" link>小红书专用</el-button>
                </div>
            </div>
            <!-- 表情选择 -->
            <div style="height: 300px;overflow-y: auto;" class="face_box">
                <div class="emoj__cells">
                    <div v-if="current_plat_type == 2">
                        <div :class="'face__sm_list'">
                            <div v-for="(item, index) in xhsemojis" :key="index" class="item">
                                <img :src="getXshFileAbsPath(item.file)" class="face"
                                    @click.stop="handleSelectFace(item)" />
                            </div>
                        </div>

                    </div>
                    <div v-else>
                        <div :class="'face__sm_list'">
                            <div v-for="(item, index) in emojis" :key="index" class="item">
                                <img :src="require('@assets/img/emoji/' + item.file)" class="face"
                                    @click.stop="handleSelectFace(item)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #reference>
            <i class="btn iconfont icon-emoj" style="font-size: 20px;cursor: pointer;" title="选择表情"></i>表情
        </template>
    </el-popover>
</template>

<script>
import { reactive, ref, computed, inject, watch } from 'vue';
import { emojis } from '@/utils/emoji-util';
import { replaceXhsEmoji, xhsemojis, getXshFileAbsPath } from "@/utils/xhs-emoji-util";
export default {
    props: {
        comment: {
            type: Object, default() {
                return {}
            }
        },
        index: {
            type: Number, default: 0
        }
    },
    emits: ["selectedIcon"],
    setup(props, { emit, expose }) {

        // --------------- props ----------------
        const plat_type_ref = inject("chatingPlatId")
        const current_plat_type = ref(plat_type_ref.value)

        const echoRef = ref(undefined);

        const faceSelectVisiable = ref(false)
        // --------------- 方法 --------------
        const show = async (plat_type, echo) => {
            plat_type_ref.value = plat_type
            faceSelectVisiable.value = true
            echoRef.value = echo
        }

        const close = async () => {
            faceSelectVisiable.value = false
        }

        watch(plat_type_ref, (newVal, oldVal) => {
            current_plat_type.value = newVal
        }, { immediate: true })

        const handleSelectFace = (item) => {
            emit('selectedIcon', { title: item.title, echo: echoRef.value })
            close()
        }
        expose({
            show,
            close
        })
        return {
            plat_type_ref,
            emojis,
            xhsemojis,
            getXshFileAbsPath,
            handleSelectFace,
            faceSelectVisiable,
            current_plat_type
        }
    }
}

</script>

<style lang="scss" scoped>
.m_checked_p0 {
    color: #1677ff;
    border-bottom: 2px solid blue;
}

.face_box {
    background: #fff;
    border: 1px solid #dedede;
    border-radius: 3px;
    box-shadow: 0 1px 6px rgba(50, 54, 62, .15);
    width: 475px;
}

.face_box .emoj__cells {
    display: block;
    padding: 12px 1px 12px 6px;
    height: 250px
}

.face_box .emoj__cells.cur {
    display: block
}

.emoj__cells .face__sm_list {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap
}

.emoj__cells .face__sm_list .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    margin-bottom: 5px;
    height: 30px;
    width: 30px
}

.emoj__cells .face__sm_list .item:hover {
    background: #dedede
}

.emoj__cells .face__sm_list .item img {
    height: 24px
}

.emoj__cells .face__lg_list {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap
}

.emoj__cells .face__lg_list .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    margin-bottom: 2px;
    height: 71px;
    width: 71px
}

.emoj__cells .face__lg_list .item img {
    height: 60px
}

.face_box .emoj__tabs {
    background: #ecf2f2
}

.emoj__tabs .emoj-tabitem {
    cursor: pointer;
    align-items: center;
    justify-content: center;
    height: 38px;
    width: 60px
}

.emoj__tabs .emoj-tabitem.on {
    background: #fff
}

.emoj__tabs .emoj-tabitem img {
    height: 24px;
    width: 24px;
    object-fit: cover
}
</style>
